import React from "react";
import Link from "next/link";
import FadeInAnimation from "../../Common/FadeInAnimation";
import { useTranslations } from '../../../locales/useTranslations';
import { BiChevronRight, BiMobile, BiLogoWordpress, BiBuildings, BiLogoChrome } from "react-icons/bi";

const WordpressEntwicklungWeitereServices = () => {
  const { t } = useTranslations();

  return (
    <>
      <div className="services-area ptb-70">
        <div className="container">
          <div className="section-title text-left">
            <span className="sub-title">{t('wordpressDevelopment_moreServices_subtitle')}</span>
            <h2>{t('wordpressDevelopment_moreServices_title')}</h2>
          </div>

          <FadeInAnimation direction="up" delay={100}>
            <div className="container">
              <div className="row">

                <div className="col-sm-6">
                  <Link href="/web-development/wordpress-betreuung/" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoWordpress />
                      </div>
                      <h3>{t('wordpressDevelopment_moreServices_support_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('wordpressDevelopment_moreServices_support_description') }} />
                      <span className="features-box-action">{t('wordpressDevelopment_moreServices_support_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoWordpress />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/web-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiLogoChrome />
                      </div>
                      <h3>{t('wordpressDevelopment_moreServices_webDevelopment_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('wordpressDevelopment_moreServices_webDevelopment_description') }} />
                      <span className="features-box-action">{t('wordpressDevelopment_moreServices_webDevelopment_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiLogoChrome />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/app-development" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiMobile />
                      </div>
                      <h3>{t('wordpressDevelopment_moreServices_appDevelopment_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('wordpressDevelopment_moreServices_appDevelopment_description') }} />
                      <span className="features-box-action">{t('wordpressDevelopment_moreServices_appDevelopment_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiMobile />
                      </div>
                    </div>
                  </Link>
                </div>

                <div className="col-sm-6">
                  <Link href="/it-consulting" className="read-more">
                    <div className="features-box">
                      <div className="icon">
                        <BiBuildings />
                      </div>
                      <h3>{t('wordpressDevelopment_moreServices_itConsulting_title')}</h3>
                      <p dangerouslySetInnerHTML={{ __html: t('wordpressDevelopment_moreServices_itConsulting_description') }} />
                      <span className="features-box-action">{t('wordpressDevelopment_moreServices_itConsulting_readMore')}
                      <BiChevronRight />
                      </span>
                      <div className="back-icon">
                        <BiBuildings />
                      </div>
                    </div>
                  </Link>
                </div>

              </div>
            </div>
          </FadeInAnimation>

        </div>
      </div>
    </>
  );
};

export default WordpressEntwicklungWeitereServices;
